/** @namespace routes */

import './admin'
import './devices'
import './operations'
import './report'

import { register } from 'tmr/tmr/ngModuleRegistry'

import * as route403Forbidden from './errors/403Forbidden/403Forbidden'
import * as route404NotFound from './errors/404NotFound/404NotFound'
import * as workstationError from './errors/workstationError/workstationError'
import * as connectionLost from './connectionLost/connectionLost'
import * as forgotPassword from './forgotPassword/forgotPassword'
import * as login from './login/login'
import * as logout from './logout/logout'
import * as temporaryLogin from './temporaryLogin/temporaryLogin'
import * as workstationRequired from './workstationRequired/workstationRequired'

export default register(
  'tmr.core.routes',
  route403Forbidden,
  route404NotFound,
  connectionLost,
  forgotPassword,
  login,
  logout,
  temporaryLogin,
  workstationRequired,
  workstationError
)
